var render = function render(){var _vm=this,_c=_vm._self._c;return _c('extra-table',{attrs:{"title":_vm.$t('parcels'),"entity":"parcels","fields":_vm.fields}})
}
var staticRenderFns = []

export { render, staticRenderFns }